import { Table } from "antd";
import { useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getPaddleProductColumns } from "./columns/columns";
import { IPaddleProduct } from "../redux/types";

interface PaddleProductTableProps {
  data: IPaddleProduct[];
}

const PaddleProductTable = ({ data }: PaddleProductTableProps) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const columns = useMemo(() => {
    const cols = getPaddleProductColumns();
    return Array.isArray(cols) ? cols : [];
  }, []);

  const safeData = useMemo(() => {
    return Array.isArray(data) ? data : [];
  }, [data]);

  const handleRowClick = (record: IPaddleProduct) => {
    navigate(`/payment-products/${record.productId}/prices`);
  };

  return (
    <div ref={tableRef}>
      <Table
        dataSource={safeData ?? []}
        columns={columns}
        rowKey="productId"
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: "pointer" },
        })}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total: number, range: [number, number]) =>
            `${range[0]}-${range[1]} of ${total} products`,
        }}
        scroll={{ x: 1400, y: "calc(100vh - 345px)" }}
        size="small"
        bordered
      />
    </div>
  );
};

export default PaddleProductTable;
